export const APP_LAYOUT_WIDTHS = {
  navigationDrawer: 280,
  navigationDrawerCollapsed: 70,
};

export const RESPONSIVE_ACTION_THRESHOLDS = {
  minContentWidthForFullActions: 1120,
};

export const DETAIL_PL_TABLE_DISPLAY_CONFIG = {
  default: {
    actionColumnWidth: "130px",
    bottomActionBar: {
      px: 3,
      py: 2,
    },
    checkboxColumnWidth: "60px",
    emptyState: {
      iconSize: 48,
      inline: false,
      p: 4,
    },
    dragColumnWidth: "40px",
    rowPaddingY: 2,
    sectionHeader: {
      iconSize: 40,
      spacing: 2,
      titleVariant: "h6",
      px: 3,
      py: 2,
    },
    tableMaxHeight: "min(560px, calc(100vh - 300px))",
    tableMinWidth: "800px",
    taxAdjustmentColumn: {
      baseWidth: 210,
      iconSlotWidth: 28,
      minWidth: 150,
      shrinkRatio: 0.16,
    },
    columns: {
      amount: "180px",
      name: "300px",
      reference: "240px",
      taxAdjustment: "210px",
    },
  },
  compact: {
    actionColumnWidth: "56px",
    bottomActionBar: {
      px: 2,
      py: 1,
    },
    checkboxColumnWidth: "52px",
    emptyState: {
      iconSize: 22,
      inline: true,
      p: 1.25,
    },
    dragColumnWidth: "44px",
    rowPaddingY: 1,
    sectionHeader: {
      iconSize: 32,
      spacing: 1,
      titleVariant: "subtitle1",
      px: 2,
      py: 1.25,
    },
    tableMaxHeight: "min(640px, calc(100vh - 240px))",
    tableMinWidth: "760px",
    taxAdjustmentColumn: {
      baseWidth: 190,
      iconSlotWidth: 28,
      minWidth: 145,
      shrinkRatio: 0.12,
    },
    columns: {
      amount: "160px",
      name: "360px",
      reference: "180px",
      taxAdjustment: "190px",
    },
  },
};

export const COMMON_TABLE_DISPLAY_CONFIG = {
  default: {
    columns: {
      action: "72px",
      actions: "72px",
      amount: "180px",
      checkbox: "56px",
      description: "300px",
      name: "300px",
      reference: "240px",
      selected: "56px",
      source: "80px",
      taxAdjustment: "210px",
    },
    controlColumnKeys: ["action", "actions", "checkbox", "selected"],
    controlSize: 40,
    headerCellPaddingX: 2,
    headerCellPaddingY: 1.5,
    rowCellPaddingX: 2,
    rowCellPaddingY: 2,
    tableMinWidth: "760px",
  },
  large: {
    columns: {
      action: "56px",
      actions: "56px",
      amount: "160px",
      checkbox: "52px",
      description: "360px",
      name: "360px",
      reference: "180px",
      selected: "52px",
      source: "72px",
      taxAdjustment: "190px",
    },
    controlColumnKeys: ["action", "actions", "checkbox", "selected"],
    controlSize: 36,
    headerCellPaddingX: 1.25,
    headerCellPaddingY: 1,
    rowCellPaddingX: 1.25,
    rowCellPaddingY: 1,
    tableMinWidth: "720px",
  },
};

export const COMPANY_LIST_DISPLAY_CONFIG = {
  default: {
    addCard: {
      contentPadding: 3,
      height: 272,
      iconPadding: 2,
      iconSize: 40,
      titleVariant: "h6",
    },
    card: {
      contentPadding: 3,
      footerMarginTop: 1.5,
      footerPaddingTop: 1.5,
      height: 272,
      iconRadius: 2.5,
      iconSize: 48,
      nameLineClamp: 2,
      topGap: 2,
    },
    cardGridItem: {
      xs: 12,
      sm: 6,
      md: 3,
      lg: 2.4,
    },
    grid: {
      spacing: 2.5,
    },
    header: {
      controlsGap: { xs: 2, md: 1.5 },
      iconSize: 40,
      mb: 2,
      px: { xs: 2.5, sm: 3 },
      py: { xs: 3, md: 3.25 },
      searchMaxWidth: 500,
      titleFontSize: { xs: "1.35rem", sm: "1.5rem", md: "1.625rem" },
    },
  },
  large: {
    addCard: {
      contentPadding: 2,
      height: 264,
      iconPadding: 1.5,
      iconSize: 34,
      titleVariant: "subtitle1",
    },
    card: {
      contentPadding: 2,
      footerMarginTop: 1.25,
      footerPaddingTop: 1.25,
      height: 264,
      iconRadius: 2,
      iconSize: 40,
      nameLineClamp: 3,
      topGap: 1.25,
    },
    cardGridItem: {
      xs: 12,
      sm: 6,
      md: 4,
      lg: 3,
      xl: 2.4,
    },
    grid: {
      spacing: 2,
    },
    header: {
      controlsGap: { xs: 1.25, md: 1 },
      iconSize: 34,
      mb: 1.25,
      px: { xs: 1.75, sm: 2 },
      py: { xs: 1.75, md: 2 },
      searchMaxWidth: 360,
      titleFontSize: { xs: "1.2rem", sm: "1.3rem", md: "1.4rem" },
    },
  },
};

export const SUB_USER_MANAGEMENT_DISPLAY_CONFIG = {
  default: {
    addCard: {
      contentPadding: 3,
      height: 220,
      iconPadding: 2,
      iconSize: 40,
      subtitleVariant: "body2",
      titleVariant: "h6",
    },
    card: {
      avatarSize: 40,
      contentPadding: 3,
      footerPaddingTop: 1.5,
      height: 220,
      nameLineClamp: 2,
      topGap: 1.5,
    },
    cardGridItem: {
      xs: 12,
      sm: 6,
      md: 3,
      lg: 2.4,
    },
    grid: {
      px: 3,
      py: 2,
      spacing: 2.5,
    },
    header: {
      controlsGap: { xs: 1.25, sm: 1.5 },
      iconSize: 40,
      mb: 2,
      mr: 3,
      px: { xs: 2.5, sm: 3 },
      py: { xs: 3, md: 3.25 },
      searchMaxWidth: 350,
      titleFontSize: { xs: "1.35rem", sm: "1.5rem", md: "1.625rem" },
    },
    section: {
      mb: 2,
      px: 3,
      py: 2,
      titleFontSize: "1rem",
    },
  },
  large: {
    addCard: {
      contentPadding: 2,
      height: 232,
      iconPadding: 1.5,
      iconSize: 34,
      subtitleVariant: "caption",
      titleVariant: "subtitle1",
    },
    card: {
      avatarSize: 36,
      contentPadding: 2,
      footerPaddingTop: 1.25,
      height: 232,
      nameLineClamp: 2,
      topGap: 1.25,
    },
    cardGridItem: {
      xs: 12,
      sm: 6,
      md: 4,
      lg: 3,
      xl: 2.4,
    },
    grid: {
      px: 2,
      py: 1.25,
      spacing: 2,
    },
    header: {
      controlsGap: { xs: 1, sm: 1.25 },
      iconSize: 34,
      mb: 1.25,
      mr: 1.5,
      px: { xs: 1.75, sm: 2 },
      py: { xs: 1.75, md: 2 },
      searchMaxWidth: 300,
      titleFontSize: { xs: "1.2rem", sm: "1.3rem", md: "1.4rem" },
    },
    section: {
      mb: 1.25,
      px: 2,
      py: 1.25,
      titleFontSize: "0.95rem",
    },
  },
};

export const DISCLOSURE_CENTER_DISPLAY_CONFIG = {
  default: {
    header: {
      actionButtonSize: "medium",
      actionGap: 1,
      contentGap: 2,
      hideSubtitle: false,
      iconSize: 40,
      searchMaxWidth: { lg: 520 },
      stackDirection: { xs: "column", lg: "row" },
      statusMinWidth: 150,
      toolMenu: false,
      titleVariant: "h6",
      px: { xs: 2, md: 3 },
      py: { xs: 1.5, md: 2 },
    },
  },
  large: {
    header: {
      actionButtonSize: "small",
      actionGap: 0.75,
      contentGap: 1.25,
      hideSubtitle: true,
      iconSize: 34,
      searchMaxWidth: { md: 320, lg: 360, xl: 420 },
      stackDirection: { xs: "column", md: "row" },
      statusMinWidth: 128,
      toolMenu: true,
      titleVariant: "subtitle1",
      px: { xs: 1.5, md: 2 },
      py: { xs: 1, md: 1.25 },
    },
  },
};

export const SCHEDULE_PANEL_DISPLAY_CONFIG = {
  default: {
    addButtonSize: 44,
    borderRadius: 3,
    contentPadding: 2,
    emptyState: {
      iconContainerSize: 80,
      iconSize: 40,
      padding: 4,
      textMaxWidth: "300px",
    },
    header: {
      controlsGap: 1.5,
      gap: 2,
      iconContainerSize: 48,
      iconRadius: 3,
      iconSize: 26,
      px: { xs: 2.5, sm: 3 },
      py: { xs: 2.5, sm: 3 },
      searchInputPaddingX: 1.5,
      searchInputPaddingY: 1.2,
      searchMaxWidth: "320px",
      searchMinWidth: "220px",
      titleVariant: "h6",
    },
    height: {
      xs: "auto",
      sm: "calc(100vh - 380px)",
      md: "calc(100vh - 320px)",
    },
    list: {
      gap: 1.5,
      px: 0.5,
      py: 1,
    },
    minHeight: { xs: "420px", sm: "520px" },
    skeleton: {
      gap: 1.5,
      itemGap: 2,
      itemPadding: 1.5,
      padding: 2,
      sideBoxSize: 36,
    },
  },
  large: {
    addButtonSize: 38,
    borderRadius: 2,
    contentPadding: 1.25,
    emptyState: {
      iconContainerSize: 48,
      iconSize: 26,
      padding: 2,
      textMaxWidth: "260px",
    },
    header: {
      controlsGap: 1,
      gap: 1.25,
      iconContainerSize: 38,
      iconRadius: 2,
      iconSize: 22,
      px: { xs: 1.5, sm: 2 },
      py: { xs: 1.5, sm: 1.75 },
      searchInputPaddingX: 1,
      searchInputPaddingY: 0.85,
      searchMaxWidth: "210px",
      searchMinWidth: "180px",
      titleVariant: "subtitle1",
    },
    height: {
      xs: "auto",
      sm: "calc(100vh - 320px)",
      md: "calc(100vh - 270px)",
    },
    list: {
      gap: 1,
      px: 0.25,
      py: 0.5,
    },
    minHeight: { xs: "360px", sm: "460px" },
    skeleton: {
      gap: 1,
      itemGap: 1.25,
      itemPadding: 1,
      padding: 1,
      sideBoxSize: 30,
    },
  },
};

export const AUTO_COLLAPSE_NAV_SECTION_KEYS = new Set([
  "mainComputationData",
  "detailPL",
]);

export const getViewportWidth = () => {
  if (typeof window === "undefined") return 0;

  return (
    window.visualViewport?.width ||
    window.innerWidth ||
    document.documentElement?.clientWidth ||
    0
  );
};

export const getAvailableContentWidth = (
  reservedWidth = APP_LAYOUT_WIDTHS.navigationDrawer
) => getViewportWidth() - reservedWidth;

export const shouldUseCompactHeaderActions = (
  reservedWidth = APP_LAYOUT_WIDTHS.navigationDrawer
) =>
  getAvailableContentWidth(reservedWidth) <
  RESPONSIVE_ACTION_THRESHOLDS.minContentWidthForFullActions;

const clampNumber = (value, min, max) => Math.min(Math.max(value, min), max);

export const getDetailPlTaxAdjustmentColumnWidth = (
  compact = false,
  viewportWidth
) => {
  const config = compact
    ? DETAIL_PL_TABLE_DISPLAY_CONFIG.compact
    : DETAIL_PL_TABLE_DISPLAY_CONFIG.default;
  const columnConfig = config.taxAdjustmentColumn;
  const availableWidth =
    typeof viewportWidth === "number"
      ? viewportWidth - APP_LAYOUT_WIDTHS.navigationDrawer
      : getAvailableContentWidth(APP_LAYOUT_WIDTHS.navigationDrawer);
  const widthPressure = Math.max(
    0,
    RESPONSIVE_ACTION_THRESHOLDS.minContentWidthForFullActions - availableWidth
  );
  const adjustedWidth = clampNumber(
    columnConfig.baseWidth - widthPressure * columnConfig.shrinkRatio,
    columnConfig.minWidth,
    columnConfig.baseWidth
  );

  return `${Math.round(adjustedWidth)}px`;
};

export const getDetailPlTableDisplayConfig = (
  compact = false,
  viewportWidth
) => {
  const config = compact
    ? DETAIL_PL_TABLE_DISPLAY_CONFIG.compact
    : DETAIL_PL_TABLE_DISPLAY_CONFIG.default;

  return {
    ...config,
    columns: {
      ...config.columns,
      taxAdjustment: getDetailPlTaxAdjustmentColumnWidth(
        compact,
        viewportWidth
      ),
    },
  };
};

export const shouldUseCompactDetailPlTable = () =>
  shouldUseCompactHeaderActions(APP_LAYOUT_WIDTHS.navigationDrawer);

export const shouldUseLargeCommonTable = () =>
  shouldUseCompactHeaderActions(APP_LAYOUT_WIDTHS.navigationDrawer);

export const getCommonTableDisplayConfig = (large = false) =>
  large
    ? COMMON_TABLE_DISPLAY_CONFIG.large
    : COMMON_TABLE_DISPLAY_CONFIG.default;

export const shouldUseLargeSchedulePanel = () =>
  shouldUseCompactHeaderActions(APP_LAYOUT_WIDTHS.navigationDrawer);

export const getSchedulePanelDisplayConfig = (large = false) =>
  large
    ? SCHEDULE_PANEL_DISPLAY_CONFIG.large
    : SCHEDULE_PANEL_DISPLAY_CONFIG.default;

export const shouldUseLargeCompanyList = () =>
  shouldUseCompactHeaderActions(APP_LAYOUT_WIDTHS.navigationDrawer);

export const getCompanyListDisplayConfig = (large = false) =>
  large
    ? COMPANY_LIST_DISPLAY_CONFIG.large
    : COMPANY_LIST_DISPLAY_CONFIG.default;

export const shouldUseLargeSubUserManagement = () =>
  shouldUseCompactHeaderActions(APP_LAYOUT_WIDTHS.navigationDrawer);

export const getSubUserManagementDisplayConfig = (large = false) =>
  large
    ? SUB_USER_MANAGEMENT_DISPLAY_CONFIG.large
    : SUB_USER_MANAGEMENT_DISPLAY_CONFIG.default;

export const shouldUseLargeDisclosureCenter = () =>
  shouldUseCompactHeaderActions(APP_LAYOUT_WIDTHS.navigationDrawer);

export const getDisclosureCenterDisplayConfig = (large = false) =>
  large
    ? DISCLOSURE_CENTER_DISPLAY_CONFIG.large
    : DISCLOSURE_CENTER_DISPLAY_CONFIG.default;

export const shouldAutoCollapseNavigation = ({ open, sectionKey }) =>
  Boolean(
    open &&
    AUTO_COLLAPSE_NAV_SECTION_KEYS.has(sectionKey) &&
    shouldUseCompactHeaderActions(APP_LAYOUT_WIDTHS.navigationDrawer)
  );
